import dynamic from 'next/dynamic';
const Layout = dynamic(() => import('../hoc/staticLayout'), { loading: () => <></>, ssr: true });
const LibraryContent = dynamic(() => import('../components/static/libraryPage'), { loading: () => <></>, ssr: true });
import { withRouter } from 'next/router';

function Library(props) {
	const meta = {
		title: "Bayan On-Demand All Access Pass | Bayan",
		description: "Learn topics like Islam In Blackamerica: From Slavery to Hip-Hop, Foundations of Islamic Studies, Prophetic Biography, Foundations of the Islamic Worldview.",
		route: "library",
	}
	return (
		<>
			<Layout theme={props.theme} meta={meta}>
				<LibraryContent router={props.router} />
			</Layout>
		</>
	);
}

export default withRouter(Library);
